// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2p4D7","author":"Table_author__52Yyd","authorImage":"Table_authorImage___olMl","unreadRow":"Table_unreadRow__yqRbH"};